import React from 'react';
import { Form, Select } from 'antd';
// import { convertToSpamVolume } from 'util/computeDataCompWithSpam';

const { Option } = Select;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRowCampaign = Form.create()(EditableRow);

class EditableCellCampaign extends React.Component {
  state = {
    editing: true,
  };

  componentDidUpdate(prevProps) {
    if ((this.props.isReset !== prevProps.isReset && this.props.isReset) || (this.props.isResetDataComp !== prevProps.isResetDataComp && this.props.isResetDataComp)) {
      this.form.resetFields();
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue) => {
    const {
      handleSave,
      // spamOfCategory
    } = this.props;
    const value = inputValue.split('_');
    // handleSave({ [key]: { prev: value[1] * 1,  next: spamOfCategory ? convertToSpamVolume(value[1] * 1, spamOfCategory) * 1 : value[1] * 1, isNotExact: value[2] === 'true' ? 1 : 0 } });
    handleSave({ [key]: { name: value[0], prev: value[1] * 1,  next: value[1] * 1, isNotExact: value[2] === 'true' ? 1 : 0 } });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, brands, loadingBuzz, categoryNameChosen } = this.props;
    const { editing } = this.state;
    const filteredBrands = brands.filter(brand => brand.category && categoryNameChosen && brand.category.toLowerCase() === categoryNameChosen.toLowerCase());
    const formItem = <Form.Item style={{ margin: 0 }}>
      {form.getFieldDecorator(dataIndex, {
        initialValue: ['none_0'],
      })(<Select disabled={!categoryNameChosen} loading={loadingBuzz} style={{ width: 200 }} optionFilterProp="children" showSearch filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
      } ref={node => (this.input = node)} onChange={e => this.save(dataIndex, e)}>
        <Option key='none' value="none_0">Chọn campaign</Option>
        {filteredBrands.map(campaign => <Option key={campaign.campaign} value={`${campaign.campaign}_${campaign.value}_${campaign.isNotExact || 0}`}>{campaign.campaign}</Option>)}
      </Select>)}
    </Form.Item>;

    return editing ? (
      formItem
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      isReset,
      isResetDataComp,
      loadingBuzz,
      brands,
      spamOfCategory,
      categoryNameChosen,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRowCampaign,
  EditableCellCampaign,
}
